var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=c5t5wnxp6mvabdrpn7wm4zt2zu/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"message-list\" data-message-list-id=\""
    + alias1(container.lambda(container.strict(depth0, "message_list_id", {"start":{"line":1,"column":51},"end":{"line":1,"column":66}} ), depth0))
    + "\" role=\"list\" aria-live=\"polite\" aria-label=\""
    + alias1(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Messages",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":1,"column":114},"end":{"line":1,"column":131}}}))
    + "\"></div>\n";
},"useData":true});